import React, { useState } from "react";
import { useSelector } from "react-redux";
import { verifyOtp, resendOtp } from "businesslogic/apis/ordersAuth";
import { getOrdersAuthData } from "businesslogic/dataStore/reducers/ordersAuth";
import { isEmpty } from "lodash-es";

import EnterOtp from "../../pages/Portfolio/EnterOtp/EnterOtp";
import Api from "../../utils/api";
import { navigate as navigateFunc } from "../../utils/functions";
import { ORDERS_AUTH_ROUTES } from "../../constants/ordersAuth";

import { ORDERS_AUTH_OTP as STRINGS } from "businesslogic/strings/ordersAuth";

const OTP_PROPS = {
  infoText: STRINGS.otp.infoText,
  dataAidSuffix: STRINGS.otp.dataAid,
  retryInfoText: STRINGS.otp.retryInfoText,
  buttonText: STRINGS.otp.buttonText,
  otpTimerInSeconds: 15,
};

const HEADER_PROPS = {
  headerTitle: STRINGS.navigationHeader.title.text,
  subtitle: STRINGS.navigationHeader.subtitle.text,
}

const ordersAuthOtpContainer = (WrappedComponent) => (props) => {
  const navigate = navigateFunc.bind(props);
  const orderData = useSelector(getOrdersAuthData);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [otpValue, setOtpValue] = useState("");

  const onChange = (val) => {
    if (!isEmpty(error)) {
      setError("");
    }
    setOtpValue(val);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const payload = {
        otp: otpValue,
        urlsafe_key: orderData.urlsafe_key,
      };
      await verifyOtp(Api, payload);
      setIsLoading(false);
      navigate(ORDERS_AUTH_ROUTES.SUCCESS);
    } catch (error) {
      setError(error.message);
      setIsLoading(false);
    }
  };

  const handleOtpResend = async () => {
    try {
      await resendOtp(Api, orderData.urlsafe_key);
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <WrappedComponent
      otpValue={otpValue}
      error={error}
      otpProps={OTP_PROPS}
      ctaTitle={STRINGS[orderData.order_type].cta}
      isButtonLoading={isLoading}
      otpErrorMessage={error}
      onChange={onChange}
      handleOtpResend={handleOtpResend}
      handleSubmit={handleSubmit}
      headerProps={HEADER_PROPS}
    />
  );
};

export default ordersAuthOtpContainer(EnterOtp);
